import apiClient from './apiClient';

export const reviewApi = {
  // Lista paginada: devuelve { count, next, previous, results }
  listItrs: (params) => apiClient.get('/review/itrs/', { params }),
  // Lista agrupada por itr_number: { count, next, previous, results: [{itr_number, version_count, versions}] }
  listItrGroups: (params) => apiClient.get('/review/itr-groups/', { params }),
  getFilters: (params) => apiClient.get('/review/filters/', { params }),
  // Detalle por ID numérico (PK)
  getItr: (itrId) => apiClient.get(`/review/itr/${itrId}/`),
  getPageText: (itrId, pageNum) =>
    apiClient.get(`/review/text/${itrId}/${pageNum}/`),
  // PDF dividido como blob (split por ITR)
  getPdfBlob: (itrId) =>
    apiClient.get(`/review/pdf/${itrId}/`, { responseType: 'blob' }),
  // PDF origen completo como blob (SourcePDF)
  getOriginPdfBlob: (itrId) =>
    apiClient.get(`/review/origin-pdf/${itrId}/`, { responseType: 'blob' }),
  // Jerarquía completa del catálogo RTA (discipline > system > sub-system > element)
  getRtaCatalogue: () => apiClient.get('/review/rta-catalogue/'),
  // Actualización parcial de campos editables de un ITR
  updateItr: (itrId, data) => apiClient.patch(`/review/itr/${itrId}/update/`, data),
  // Lanzar importación de trazabilidad
  triggerImport: (jobId, outputDir) =>
    apiClient.post('/review/import/', { job_id: jobId || null, output_dir: outputDir || null }),
  // Exportar Excel enriquecido con datos del log FDCT
  exportFdct: () => apiClient.get('/review/export-fdct/', { responseType: 'blob' }),
  // Cambio de rango de páginas (resplit interactivo)
  resplitPreview: (itrId, pageStart, pageEnd) =>
    apiClient.post(`/review/itr/${itrId}/resplit-preview/`, { page_start: pageStart, page_end: pageEnd }),
  getResplitPreviewPdfBlob: (itrId) =>
    apiClient.get(`/review/itr/${itrId}/resplit-preview-pdf/`, { responseType: 'blob' }),
  confirmResplit: (itrId, pageStart, pageEnd, metadata) =>
    apiClient.post(`/review/itr/${itrId}/confirm-resplit/`, { page_start: pageStart, page_end: pageEnd, metadata }),
};

